module.exports = __webpack_public_path__ + "media/images/aloe/illustrations/add-to-cart-47ba0f7ef547ab2ebd46bcc13312c8dc.svg";